export enum subjectRequestFormEnum {
    INSCRICAO_MUNICIPAL = 'SOLICITAÇÃO DE INSCRIÇÃO MUNICIPAL',
    SOLICITACAO_ALTERACAO_CADASTRAL_REGULARIZACAO_ALVARA = 'SOLICITAÇÃO DE ALTERAÇÃO CADASTRAL E REGULARIZAÇÃO DE ALVARÁ',
    SOLICITACAO_INSCRICAO_MUNICIPAL_EXPEDICAO_ALVARA = 'SOLICITAÇÃO DE INSCRIÇÃO MUNICIPAL E EXPEDIÇÃO DE ALVARÁ',
}